import React from 'react';
import { Container, Grid, Typography, Card, CardContent, CardMedia, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; // Add this import

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      title: t('services.acupuncture.title'),
      image: '/images/acupuncture.jpg',
      description: t('services.acupuncture.description'),
      treatments: []
    },
    {
      title: t('services.electroacupuncture.title'),
      image: '/images/electroacupuncture.png',
      description: t('services.electroacupuncture.description'),
      treatments: []
    },
    {
      title: t('services.cupping.title'),
      image: '/images/cupping.jpg',
      description: t('services.cupping.description'),
      treatments: []
    },
    {
      title: t('services.guaSha.title'),
      image: '/images/guasha.png',
      description: t('services.guaSha.description'),
      treatments: []
    },
    {
      title: t('services.manualTherapy.title'),
      image: '/images/massage.jpg',
      description: t('services.manualTherapy.description'),
      treatments: []
    },
    {
      title: t('services.infraLight.title'),
      image: '/images/infraylight.jpg',
      description: t('services.infraLight.description'),
      treatments: []
    },
    {
      title: t('services.herbs.title'),
      image: '/images/herb.jpg',
      description: t('services.herbs.description'),
      treatments: [],
      link: "/herbtea" // Add link to herbs page
      
    },
    {
      title: t("telemedicine.title"),
      image: "/images/telemedcine.png",
      description: t("telemedicine.subtitle"),
      treatments: [],
      link: "/telemedicine" // Add link to telemedicine page
    }
  ];

  return (
    <Box sx={{ background: theme => theme.palette.background.gradient, py: 6 }}>
      <Container>
        <Typography variant="h2" align="center" gutterBottom>
          {t('services.title')}
        </Typography>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={6} key={index}>
                
              <Card elevation={3}>
                <CardMedia
                  component="img"
                  height="200"
                  image={`${service.image}`}
                  alt={service.title}
                />
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body1" paragraph>
                    {service.description}
                  </Typography>
                  {service.treatments.length > 0 && (
                    <ul>
                      {service.treatments.map((treatment, idx) => (
                        <li key={idx}>
                          <Typography variant="body1">{treatment}</Typography>
                        </li>
                      ))}
                    </ul>
                  )}
                  {service.link && (
                    <Button 
                      component={Link} 
                      to={service.link} 
                      variant="contained" 
                      color="primary" 
                      sx={{ mt: 2 }}
                    >
                      {t('nav.learnMore', 'Learn More')}
                    </Button>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;